const skills = [
  {
    icon: 'html-five',
    name: 'HTML',
  },
  {
    icon: 'css3',
    name: 'CSS',
  },
  {
    icon: 'sass',
    name: 'Sass',
  },
  {
    icon: 'javascript',
    name: 'JavaScript',
  },
  {
    icon: 'react',
    name: 'React',
  },
  {
    icon: 'node-dot-js',
    name: 'NodeJS',
  },
  {
    icon: 'typescript',
    name: 'TypeScript',
  },
  {
    icon: 'docker',
    name: 'Docker',
  },
  {
    icon: 'mysql',
    name: 'MySQL',
  },
  {
    icon: 'jest',
    name: 'Jest',
  },
  {
    icon: 'github',
    name: 'Github',
  },
  {
    icon: 'git',
    name: 'Git',
  },
  {
    icon: 'php',
    name: 'PHP',
  },
  {
    icon: 'codeigniter',
    name: 'Code Igniter',
  },
];

export default skills;
